/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:DocumentsByTagCtrl
 * @description
 * # DocumentsByTagCtrl
 * Controller of the cimerFrontEndApp
 */

angular.module('cimerFrontEndApp').controller('DocumentsByTagCtrl', ['$scope', '$location', '$uibModal', '$http', 'Session', 'DocumentService', 'TagService', 'ApiUrl', function ($scope, $location, $uibModal, $http, Session, DocumentService, TagService, ApiUrl) {
    'use strict';
    
    var _apiUrl = ApiUrl.url('/Tag/');
    var self = this;


    $scope.displaySave = false;
    $scope.selectedTag;


    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isCurriculaAdmin)) {
        $location.url('/');
        return;
    }

    //Get the list of Tags
    DocumentService.getAllDocumentTags().then(function (results) {
        $scope.Tags = [];
        angular.forEach(results.data, function(t)
        {
            if (t.Category.ResearchRoleID === 1) {
                $scope.Tags.push(t);
            }
        });
    }, function () {
        $scope.Tags = null;
    });

    //Get the list of Documents By Tag
    $scope.getDocumentsByTag = function (tag) {
        TagService.getDocumentsByTag(tag).then(function (result) {
            $scope.DocumentList = result.data;
        }, function () {
            $scope.DocumentList = null;
        }).finally(function () {
            $scope.displaySave = false;
            $scope.selectedTag = tag;
        });
    };

    //for the toggle display of the save button

    $scope.sortableOptions = {
        update: function (e, ui) {
            console.log(e);
            $scope.displaySave = true;
            $scope.$apply();
        }
    };

    $scope.saveNewDocumentOrder = function () {
        var closeModal = $uibModal.open({
            animation: true,
            templateUrl: 'saveDocumentOrder.html',
            controller: 'saveDocumentOrderCtrl'
        });
        closeModal.result.then(function (accepted) {
            if (accepted) {
                TagService.saveDocumentOrder($scope.DocumentList, $scope.selectedTag).then(function (response) {
                    $scope.displaySave = false;
                    $scope.$apply;
                });
            }
        });
    };
}])
.controller('saveDocumentOrderCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    'use strict';
     $scope.accept = function () {
        $uibModalInstance.close(true);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);
